<template>
  <div>
    <BaseList
      ref="baseListRef"
      :columns="columns"
      :data="TotalInfo && TotalInfo.rows ? TotalInfo.rows : []"
      :pagination="
        TotalInfo
          ? {
              total: TotalInfo.count,
              current: TotalInfo.page,
              pageSize: TotalInfo.limit,
            }
          : {}
      "
      :titleAdd="$t('i18nCommon.AddOrder')"
      :isShowOrderStatus="true"
      @change="handleTableChange"
      @addData="addData"
      @editRow="editRow"
      @deleteRow="deleteRow"
      @onDblclick="onDblclick"
      @loadDataFilter="loadDataFilter"
    >
    </BaseList>
    <div v-if="isShow && order && Object.keys(order).length > 0">
      <a-modal v-model:open="isShow" centered :width="800" :closable="false">
        <div class="header-detail flex justify-between mb-6">
          <div class="font-bold text-2xl">
            {{ $t("i18nCommon.TitleDetailInfo") }}
          </div>
          <div
            class="text-white h-9 w-36 bg-slate-900 rounded-lg flex justify-center items-center"
          >
            {{ $t("i18nCommon.Order") }}
          </div>
        </div>
        <div class="content">
          <div class="product-detail-form">
            <a-form
              ref="ruleFormRef"
              :model="ruleForm"
              :rules="rules"
              label-width="120px"
              class="demo-ruleForm"
              :size="formSize"
              status-icon
            >
              <div class="flex columns-2">
                <a-form-item prop="customer" testek="customer" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.Customer") }}
                    </div>
                    <a-input v-model:value="order.customerId.id" :disabled="true" />
                  </div>
                </a-form-item>
                <a-form-item prop="phone" testek="phone" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.Phone") }}
                    </div>
                    <a-input v-model:value="order.shippingPhoneNum" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-2">
                <a-form-item prop="shipPhone" testek="shipPhone" class="w-full mr-8">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.ShipPhone") }}
                    </div>
                    <a-input v-model:value="order.shippingPhoneNum" :disabled="true" />
                  </div>
                </a-form-item>
                <a-form-item prop="email" testek="email" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">Email</div>
                    <a-input v-model:value="order.customerId.email" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-1">
                <a-form-item prop="shipAddress" testek="shipAddress" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.ShipAddress") }}
                    </div>
                    <a-input v-model:value="order.shippingAddress" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-2">
                <a-form-item
                  prop="invoiceAddress"
                  testek="Same with shipping address"
                  class="w-full mr-8"
                >
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.InvoiceAddress") }}
                    </div>
                    <h-checkbox
                      class="ml-1"
                      v-model:value="order.sameAddress"
                      :disabled="true"
                    />
                    <div class="ml-1">
                      {{ $t("i18nProduct.SameWithShippingAddress") }}
                    </div>
                  </div>
                </a-form-item>
                <a-form-item prop="employee" testek="employee" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.Employee") }}
                    </div>
                    <a-input v-model:value="order.employeeId" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
              <div class="columns-1">
                <a-form-item prop="invoiceAddress" testek="invoiceAddress" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.InvoiceAddress") }}
                    </div>
                    <a-input v-model:value="order.invoiceAddress" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
              <a-form-item v-if="order.orderItems && order.orderItems.length">
                <div>
                  <div class="table-items">
                    <a-table
                      bordered
                      :data-source="order.orderItems"
                      :columns="columnViews"
                      :pagination="false"
                      :scroll="{ y: '250px' }"
                    >
                      <template #bodyCell="{ column, record }">
                        <template v-if="column.key === 'name'">
                          <div class="name-text">
                            {{ record[`${column.dataIndex}`] }}
                          </div>
                        </template>
                        <template
                          v-if="
                            record &&
                            column.keyIndex === 'supplierObject' &&
                            record.supplier
                          "
                        >
                          <div class="name-text">
                            {{ record.supplier[`${column.dataIndex}`] }}
                          </div>
                        </template>
                        <template
                          v-if="
                            record &&
                            column.keyIndex === 'productObject' &&
                            record.product
                          "
                        >
                          <div class="name-text">
                            {{ record.product[`${column.dataIndex}`] }}
                          </div>
                        </template>
                        <template
                          v-if="
                            record &&
                            column.keyIndex === 'categoryObject' &&
                            record.category
                          "
                        >
                          <div class="name-text">
                            {{ record.category[`${column.dataIndex}`] }}
                          </div>
                        </template>
                        <template
                          v-if="
                            record &&
                            column.dataIndex === 'status' &&
                            record.status
                          "
                        >
                          <span>
                            <a-tag
                              :color="
                                record &&
                                record.status &&
                                (record.status.toUpperCase() === 'INACTIVE' ||
                                  record.status.toUpperCase() === 'CANCELLED')
                                  ? 'volcano'
                                  : 'green'
                              "
                            >
                              {{ record.status.toUpperCase() }}
                            </a-tag>
                          </span>
                        </template>
                      </template>
                    </a-table>
                  </div>
                </div>
              </a-form-item>
            </a-form>
          </div>
        </div>
        <template #footer>
          <a-button key="back" @click="isShow = false">{{
            $t("i18nCommon.Close")
          }}</a-button>
        </template>
      </a-modal>
    </div>
  </div>
</template>
<script>
import BaseList from "@/views/base/BaseList.vue";
import { mapActions, mapGetters } from "vuex";
import { ModuleOrder } from "@/store/module-const";
import { Modal } from "ant-design-vue";
export default {
  name: "OrderList",
  components: {
    BaseList,
  },
  data() {
    return {
      columns: [],
      pagination: {
        total: 200,
        current: 1,
        pageSize: 20,
      },
      order: {},
      isShow: false,
      loadDataPath: false,
      columnViews :[]
    };
  },
  computed: {
    ...mapGetters(ModuleOrder, ["TotalInfo"]),
  },
  async created() {
    const me = this;
    me.initDataStatic();
    me.$emitter.on("LoadDataOrder", me.loadDataFilter);
  },
  mounted() {
    const me = this;
    me.loadDataGrid();
  },
  beforeDestroy() {
    const me = this;
    me.$emitter.off("LoadDataOrder", me.loadDataFilter);
  },
  methods: {
    ...mapActions(ModuleOrder, ["getOrders", "updateOrder", "deleteOrder", "getOrder"]),
    handleTableChange: _.debounce(async function (page) {
      const me = this;
      me.pagination.current = page.current;
      me.pagination.pageSize = page.pageSize;
      me.pagination.total = page.total;
      await me.loadDataGrid();
    }, 300),
    initDataStatic() {
      const me = this;
      me.columns = [
        {
          fixed: "left",
          title: me.$t("i18nCommon.OrderInfo.ShippingAddress"),
          dataIndex: "shippingAddress",
          sorter: (a, b) =>
            me.$commonFunc.sortColumn(a.shippingAddress, b.shippingAddress),
          columnKey: "name",
        },
        {
          title: me.$t("i18nCommon.OrderInfo.ShippingPhone"),
          dataIndex: "shippingPhoneNum",

          sorter: (a, b) =>
            me.$commonFunc.sortColumn(a.shippingPhoneNum, b.shippingPhoneNum),
          columnKey: "name",
        },
        {
          title: me.$t("i18nCommon.OrderInfo.InvoiceAddress"),
          dataIndex: "invoiceAddress",

          sorter: (a, b) => me.$commonFunc.sortColumn(a.invoiceAddress, b.invoiceAddress),
          columnKey: "name",
        },
        {
          title: me.$t("i18nCommon.OrderInfo.Quantity"),
          dataIndex: "quantity",
          sorter: (a, b) => a.quantity - b.quantity,
          align: "right",
        },
        {
          title: me.$t("i18nCommon.OrderInfo.Total"),
          dataIndex: "amount",
          sorter: (a, b) => a.amount > b.amount,
          align: "right",
        },
        {
          title: me.$t("i18nCommon.OrderInfo.Status"),
          dataIndex: "status",
          align: "center",
        },
        {
          title: me.$t("i18nCommon.Action"),
          key: "rightWidgetDefault",
          fixed: "right",
          width: 150,
        },
      ];

      me.columnViews = [
        {
          title: me.$t("i18nCommon.Product"),
          dataIndex: "productName",
          keyIndex: "productObject",
        },
        {
          title: me.$t("i18nCommon.Quantity"),
          dataIndex: "quantity",
          width: "25%",
        },
        {
          title: me.$t("i18nCommon.Price"),
          dataIndex: "price",
          keyIndex: "productObject",
        },
        {
          title: me.$t("i18nCommon.DiscountRate"),
          dataIndex: "discountRate",
          keyIndex: "productObject",
        },
        {
          title: me.$t("i18nProduct.Status"),
          dataIndex: "status",
          width: 150,
          align: "center",
        },
      ];
    },

    async loadDataGrid() {
      const me = this;
      let payload = {
        ...me.payload,
        limit: me.pagination.pageSize,
        page: me.pagination.current,
      };
      await me.getOrders(payload);
    },
    loadDataFilter: _.debounce(async function (params) {
      const me = this;
      me.loadDataPath = true;
      if (params && me.$refs.baseListRef) {
        me.$refs.baseListRef.params.status = params.status;
      }
      let payload = {
        ...me.payload,
        ...params,
        limit: me.pagination.pageSize,
        page: 1,
      };
      await me.getOrders(payload);
    }, 300),
    addData() {
      const me = this;
      me.$router.push("/create-order");
    },
    editRow: _.debounce(async function (dataRow) {
      const me = this;
      if (!dataRow) return;
      me.$router.push("/create-order");
      setTimeout(() => {
        me.$emitter.emit("LoadEditOrder", {
          id: dataRow.id,
          mode: me.$enum.Mode.Edit,
        });
      }, 300);
    }, 300),

    deleteRow: _.debounce(async function (dataRow) {
      const me = this;
      if (!dataRow) {
        me.$messageNotification.messageNotification(
          me.$t("i18nCommon.DeleteOrderFail"),
          "warning"
        );
        return;
      }

      Modal.confirm({
        title: me.$t("i18nCommon.Confirm"),
        content: me.$t("i18nCommon.DeleteOrderConfirm", {
          name: dataRow.productName,
        }),
        okText: me.$t("i18nCommon.Yes"),
        cancelText: me.$t("i18nCommon.No"),
        centered: true,
        async onOk() {
          let result = await me.deleteOrder({ id: dataRow.id });
          if (result && result.code == 200) {
            await me.loadDataGrid();
            //Thông báo
            me.$messageNotification.messageNotification(
              me.$t("i18nCommon.DeleteOrderSuccess")
            );
          } else if (result && (result.statusCode == 400 || result.statusCode == 409)) {
            me.$messageNotification.messageNotification(result.message, "warning");
          } else {
            me.$messageNotification.messageNotification(
              me.$t("i18nCommon.DeleteOrderFail"),
              "warning"
            );
          }
        },
      });
    }, 300),

    async onDblclick(params) {
      const me = this;
      if (!params || !params.id) return;

      //lấy dữ liệu chi tiết từ API
      me.order = await me.getOrder({ id: params.id });
      if (me.order) {
        me.isShow = true;
      } else {
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ant-input[disabled] {
  background: initial !important;
  color: initial !important;
}
</style>
